module.exports = __webpack_public_path__ + "static/media/video1.d8a58ad4.svg";